import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "room-object" }
const _hoisted_3 = { class: "room-object__head" }
const _hoisted_4 = { class: "room-object__icon text-gray" }
const _hoisted_5 = { class: "bt-icon bt-icon--m" }
const _hoisted_6 = { class: "fs-18" }
const _hoisted_7 = {
  key: 0,
  class: "fs-14 text-gray"
}
const _hoisted_8 = {
  key: 1,
  class: "fs-14 text-gray"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "room-object__reorder-handle"
}
const _hoisted_11 = { class: "bt-icon bt-icon--m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_SceneTimeObjectInline = _resolveComponent("SceneTimeObjectInline")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "card--scene-wizard mb-2" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                (
                                        _ctx.getSceneObjectIconFromType(
                                            _ctx.item.sceneObjectType
                                        )
                                    )
                  ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                      key: 0,
                      src: 
                                        require(`@/assets/images/icons/${_ctx.getSceneObjectIconFromType(
                                            _ctx.item.sceneObjectType
                                        )}.svg`)
                                    
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.objectName), 1),
            (
                                _ctx.item.sceneObjectType !==
                                _ctx.SceneObjectType.DateTime
                            )
              ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.SceneUtils.getObjectDescription(_ctx.item)), 1))
              : (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_SceneTimeObjectInline, { "time-object": _ctx.item }, null, 8, ["time-object"])
                ]))
          ])
        ]),
        (!_ctx.reorderable)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode(_component_Button, {
                class: "p-button-text ml-1 fs-18",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAction('remove', _ctx.item)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "p-button-text ml-1 fs-18",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAction('edit', _ctx.item)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require(`@/assets/images/icons/icon-reorder-drag-and-drop.svg`)
                            
                }, null, 8, ["src"])
              ])
            ]))
      ])
    ]),
    _: 1
  }))
}